"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AgoraConsole = void 0;
const native_rtc_1 = require("@iris/native-rtc");
class AgoraConsole {
    static getDate() {
        const timestamp = new Date();
        return `${timestamp.toLocaleTimeString()}:${('00' + timestamp.getMilliseconds()).slice(-3)}`;
    }
    static debug(msg) {
        if (AgoraConsole.logLevel > native_rtc_1.LOG_LEVEL.LOG_LEVEL_NONE) {
            console.log(`[${this.getDate()}][Iris debug]:${msg}`);
        }
    }
    static log(msg) {
        if (AgoraConsole.logLevel > native_rtc_1.LOG_LEVEL.LOG_LEVEL_NONE &&
            AgoraConsole.logLevel <= native_rtc_1.LOG_LEVEL.LOG_LEVEL_INFO) {
            console.log(`[${this.getDate()}][Iris log]:${msg}`);
        }
    }
    static warn(msg) {
        if (AgoraConsole.logLevel > native_rtc_1.LOG_LEVEL.LOG_LEVEL_NONE &&
            AgoraConsole.logLevel <= native_rtc_1.LOG_LEVEL.LOG_LEVEL_WARN) {
            console.log(`[${this.getDate()}][Iris warning]:${msg}`);
        }
    }
    static error(msg) {
        if (AgoraConsole.logLevel > native_rtc_1.LOG_LEVEL.LOG_LEVEL_NONE &&
            AgoraConsole.logLevel <= native_rtc_1.LOG_LEVEL.LOG_LEVEL_ERROR) {
            console.error(`[${this.getDate()}][Iris error]:${msg}`);
        }
    }
}
exports.AgoraConsole = AgoraConsole;
AgoraConsole.logLevel = native_rtc_1.LOG_LEVEL.LOG_LEVEL_INFO;
